import { Component, OnInit } from '@angular/core';
import {MessagingService} from '../../services/messaging.service';
import {TdoNoteFilterModel} from '../../main-interface/controls/tdo-notes/models/tdo-note-filter.model';
import {StaticDataService} from '../../services/static-data.service';
import {MessagingConstants} from '../../models/MessagingConstants';
import {SignalrService} from '../../services/socket/signalr.service';
import {GetClockTime} from './models/get-clock-time';
import {SocketModel} from '../../models/socket.model';
import {AzureBlobStorageService} from '../../services/blob/azure-blob-storage.service';
import {FileHelperService} from '../../services/file-helper.service';
import {FileManagerService} from '../../modules/file-manager/file-manager.service';
import {Globals} from '../../globals';
import {DocumentUploadModel} from '../../models/document/document-upload.model';
import {DocumentClassEnum} from '../../models/enum/document/document-class.enum';
import {DocumentTypeEnum} from '../../models/enum/document/document-type.enum';
import {DocumentFileTypeEnum} from '../../models/enum/document/document-file-type.enum';
import {PatientSearchModel} from '../../models/patient/patient-search.model';

@Component({
  selector: 'app-testing',
  templateUrl: './testing.component.html',
  styleUrls: ['./testing.component.css']
})
export class TestingComponent implements OnInit {
  section = '';
  uploadProgress: number = 0;
  estimatedTimeLeft: string = '';

  // Socket testing
  public currentMessage: GetClockTime = new GetClockTime('');
  public allMessages: GetClockTime = new GetClockTime('');
  public canSendMessage: boolean = false;
  // End Socket testing

  today: Date = new Date();

  constructor(private messagingService: MessagingService,
              private globals: Globals,
              private signalRService: SignalrService,
              private azureBlobService: AzureBlobStorageService,
              private fileManagerService: FileManagerService,
              private fileHelperService: FileHelperService,
              private staticDataService: StaticDataService)
  {
    //
  }

  ngOnInit(): void {
  }

  filterNotes() {
    const model = new TdoNoteFilterModel();
    model.addNoteFilterCategoriesByIds(this.staticDataService, ['00000018-1000-0000-0000-000000000002']);
    this.messagingService.sendComponentMessage(MessagingConstants.NOTES_FILTER, model);
  }

  // Socket Methods
  startSocketTesting() {
    this.subscribeToEvents();
    // this can check for connection exist or not.
    this.canSendMessage = this.signalRService.connectionExists;

    this.signalRService.sendToBackend(new SocketModel(SocketModel.INCOMING_MESSAGE, {name: 'tester'}));

    // this method call every second to tick and respone tansfered to client.
    /*setInterval(() => {
      this.signalRService.sendTime();
    }, 1000);*/
  }

  private subscribeToEvents(): void {
    // if connection exists it can call of method.
    this.signalRService.connectionEstablished.subscribe(() => {
      this.canSendMessage = true;
    });
    // finally our service method to call when response received from server event and transfer response to some variable to be shwon on the browser.
    this.signalRService.messageReceived.subscribe((message: any) => {
      this.allMessages = message;
    });
  }
  // End Socket Methods

  // Azure blob testing
  picturesList: string[] = [];

  startAzureBlobTesting() {
    /*this.azureBlobService.getSas().subscribe((res) => {

    });*/
  }

  private reloadImagesList() {
    this.azureBlobService.listBlobs(list => {
      this.picturesList = list;
    });
  }

  deleteBlob(pic: string) {
    this.azureBlobService.deleteBlob(pic, () => {
      console.log('Delete successfull');
      this.reloadImagesList();
    });
  }

  downloadBlob(name: string) {
    this.azureBlobService.downloadBlob(name, blob => {
      let url = window.URL.createObjectURL(blob);
      window.open(url);
    });
  }

  listBlobsClick() {
    this.reloadImagesList();
  }

  onAzureUploadFileChange(list: FileList) {
    const models: DocumentUploadModel[] = [];
    for (let i = 0; i < list.length; i++) {
      const file = list.item(i);

      const uploadModel = new DocumentUploadModel();
      uploadModel.blob = file;
      uploadModel.patientId = this.globals.currentPatientId;
      uploadModel.docClassId = DocumentClassEnum.Original;
      uploadModel.docTypeId = DocumentTypeEnum.Scan;
      uploadModel.hasAnnotation = false;
      uploadModel.docTagIds = [];
      uploadModel.patientCaseId = this.globals.currentPatientCaseId;
      models.push(uploadModel);
    }

    this.fileManagerService.uploadDocuments(models).subscribe((documents) => {
      console.log('Document upload complete');
    });

  }

  onPatientSelect(event: PatientSearchModel) {
    console.log(event.FirstName);
  }
}
